import type { FilterSpecification } from "maplibre-gl";
import type { AgglomerationI } from "@/types/base";

export const EDA_ACTIVE_HEXGROUP_FILTER: FilterSpecification = [
  "==",
  ["get", "is_eda_active"],
  true,
];

export const getActiveEdaHexgroupIds = (
  agglomerations?: AgglomerationI[]
): number[] =>
  (agglomerations || []).flatMap((agglomeration) =>
    agglomeration.hexgroups
      .filter((hexgroup) => hexgroup.is_eda_active)
      .map((hexgroup) => hexgroup.id)
  );

export const buildHexgroupIdFilter = (
  hexgroupIds: number[]
): FilterSpecification =>
  hexgroupIds.length
    ? ([
        "in",
        ["get", "hexgroup_id"],
        ["literal", hexgroupIds],
      ] as FilterSpecification)
    : (["==", ["get", "hexgroup_id"], -1] as FilterSpecification);

export const buildHexFillOverlayFilter = ({
  isEdaMode,
  activeEdaFilter,
  selectedHexGroupId,
}: {
  isEdaMode: boolean;
  activeEdaFilter: FilterSpecification;
  selectedHexGroupId?: number;
}): FilterSpecification => {
  const filters: FilterSpecification[] = [];

  if (isEdaMode) {
    filters.push(activeEdaFilter);
  }

  if (selectedHexGroupId) {
    filters.push(["!=", ["get", "hexgroup_id"], selectedHexGroupId]);
  }

  return filters.length
    ? (["all", ...filters] as FilterSpecification)
    : ["all"];
};

export const buildHexBorderFilter = ({
  isEdaMode,
  selectedHexGroupId,
}: {
  isEdaMode: boolean;
  selectedHexGroupId?: number;
}): FilterSpecification => {
  const filters: FilterSpecification[] = [];

  if (isEdaMode) {
    filters.push(EDA_ACTIVE_HEXGROUP_FILTER);
  }

  if (selectedHexGroupId) {
    filters.push(["!=", ["get", "id"], selectedHexGroupId]);
  }

  return filters.length
    ? (["all", ...filters] as FilterSpecification)
    : ["all"];
};
